import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Table from '../components/Table';
import SearchBar from '../components/Searchbar';
import ModalOrderDetail from '../components/ModalOrderDetail';

//const IP = "http://143.110.239.79:5010/"
const IP = "https://pepetoys-backend.mindnt.com.mx/api/"
//const IP = "http://localhost:5010/"

const Ventas = ({ onMenuSelect }) => {
  const [sales, setSales] = useState([]);
  const [filteredSales, setFilteredSales] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMenu, setSelectedMenu] = useState('ventas');
  const [isLoading, setIsLoading] = useState(false);
  const [showOrderDetail, setShowOrderDetail] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  // Filter sales based on search term
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredSales(sales);
    } else {
      const filtered = sales.filter(sale =>
        sale.customer_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        sale.customer_phone?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        sale.id?.toString().includes(searchTerm) ||
        sale.code_order?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        sale.total_amount?.toString().includes(searchTerm)
      );
      setFilteredSales(filtered);
    }
  }, [sales, searchTerm]);

  // Fetch sales from API
  const fetchSales = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${IP}orders/get-all-sales`);
      if (response.ok) {
        const result = await response.json();
        if (result.status === 'success') {
          setSales(result.data);
        }
      }
    } catch (error) {
      console.error('Error fetching sales:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSales();
  }, []);

  const handleMenuSelect = (menuId) => {
    setSelectedMenu(menuId);
    if (onMenuSelect) {
      onMenuSelect(menuId);
    }
  };

  const handleViewOrderDetail = (order) => {
    setSelectedOrder(order);
    setShowOrderDetail(true);
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-MX', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const columns = [
    {
      key: 'id',
      title: 'ID Venta',
      width: '100px',
      align: 'center',
      render: (value) => `#${value}`
    },
    {
      key: 'code_order',
      title: 'Código de Orden',
      width: '150px',
      align: 'center',
      render: (value) => (
        <span className="font-mono text-sm bg-gray-100 px-2 py-1 rounded">
          {value || 'N/A'}
        </span>
      )
    },
    {
      key: 'customer_name',
      title: 'Cliente',
      width: '200px',
      render: (value, item) => (
        <div>
          <div className="font-medium text-gray-900">{value}</div>
          <div className="text-sm text-gray-500">{item.customer_phone}</div>
        </div>
      )
    },
    {
      key: 'sale_date',
      title: 'Fecha de Venta',
      width: '180px',
      render: (value) => formatDate(value)
    },
    {
      key: 'items',
      title: 'Detalles',
      width: '150px',
      align: 'center',
      render: (value, item) => (
        <div className="flex justify-center">
          <button
            onClick={() => handleViewOrderDetail(item)}
            className="px-3 py-1 bg-blue-500 hover:bg-blue-600 text-white text-xs rounded-md transition-colors"
          >
            Ver Detalle
          </button>
        </div>
      )
    },
    {
      key: 'total_amount',
      title: 'Total',
      width: '120px',
      align: 'right',
      render: (value) => (
        <span className="font-semibold text-gray-900">
          ${value.toFixed(2)}
        </span>
      )
    }
  ];

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar
        onMenuSelect={handleMenuSelect}
        activeMenu={selectedMenu}
      />

      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Ventas</h1>
              <p className="text-gray-600 mt-1">Historial de ventas realizadas</p>
            </div>
            <div className="flex items-center space-x-4">
              <SearchBar
                value={searchTerm}
                onChange={setSearchTerm}
                placeholder="Buscar por cliente, teléfono, ID, código..."
                className="w-80"
                disabled={isLoading}
              />
              <div className="text-sm text-gray-500">
                Total: {sales.length} venta(s)
              </div>
            </div>
          </div>
        </header>

        {/* Content */}
        <main className="flex-1 overflow-auto p-6">
          <div className="bg-white rounded-lg shadow-sm">
            {isLoading ? (
              <div className="flex justify-center items-center py-8">
                <div className="text-gray-500">Cargando ventas...</div>
              </div>
            ) : (
              <>
                {searchTerm && (
                  <div className="px-6 py-3 border-b border-gray-200 bg-gray-50">
                    <p className="text-sm text-gray-600">
                      {filteredSales.length} resultado(s) para "{searchTerm}"
                      {filteredSales.length !== sales.length && (
                        <span className="ml-2 text-gray-500">
                          de {sales.length} total(es)
                        </span>
                      )}
                    </p>
                  </div>
                )}
                <Table
                  columns={columns}
                  data={filteredSales}
                  emptyMessage={
                    searchTerm
                      ? `No se encontraron ventas que coincidan con "${searchTerm}"`
                      : "No hay ventas registradas"
                  }
                />
              </>
            )}
          </div>
        </main>
      </div>

      {/* Order Detail Modal */}
      {showOrderDetail && (
        <ModalOrderDetail
          isOpen={showOrderDetail}
          onClose={() => {
            setShowOrderDetail(false);
            setSelectedOrder(null);
          }}
          orderData={selectedOrder}
        />
      )}
    </div>
  );
};

export default Ventas;
